import WorldCheckLogoImage from 'assets/images/world_check_logo.png'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  justify-content: center;
  img {
    width: 25rem;
  }
`

export const WorldCheckLogo = (): JSX.Element => {
  return (
    <Container>
      <img alt='robot' src={WorldCheckLogoImage} />
    </Container>
  )
}
